// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".bottom-tip-wrap .loadTips[data-v-8d612402] {\n  padding: 20px 0;\n  font-size: 14px;\n  color: #757575;\n}\n.bottom-tip-wrap .loadTips .load[data-v-8d612402] {\n    width: 24px;\n    height: auto;\n    margin-right: 5px;\n    animation: loading-rotate 2s linear infinite;\n}\n", ""]);
// Exports
module.exports = exports;
